import React, { useEffect } from 'react'
import { projectDetails } from './Data'
import { Link, useParams } from 'react-router-dom';
import img from '../Section/Images/projectDetails/detis/design.png'
import img1 from '../Section/Images/projectDetails/detis/develop.png'
import img2 from '../Section/Images/projectDetails/detis/research.png'

const ProjectDetials = () => {

  const { projectId } = useParams(); // Get the project ID from the URL

  // Assuming the first project ID is 1 for this example
  const firstProjectId = 1; // Set this to whatever the first project's ID is in your data

  // Find the project details based on the project ID
  const project = projectDetails.find(project => project.id === parseInt(projectId, 10));

  // This useEffect hook will run when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  if (!project) {
    return <div>Project not found</div>;
  }
  return (
    <>
        <div className="projectDetails">
          <Link to="/"  style={{color:"white"}}>
            <span class="material-symbols-outlined" style={{position:"absolute", left:"5%"}}>
              keyboard_backspace
            </span>
          </Link>
          <div className="pname">Project name</div>
          <h1 className='pheader'>{project.projectName}</h1>
          <div className="phone-frame">
            <iframe width="560" height="315" src={project.video} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </div>
          {/* project link */}
          {project.id === firstProjectId && ( // Check if the project is the first one
            <div className="plink">
              <div>project build link </div>
              <a href={project.projectLink} target='_blank' rel="noopener noreferrer">{project.projectLink}</a>
            </div>
          )}
          {/* about project */}
          <div className="aboutp">
            <div className='pheader'>About The Project</div>
            <p>{project.description.desc1}</p>
          </div>
          {/* project tools */}
          <div className="ptools">
            <div className='pheader'>Tools Used</div>
            <div className="flex">
                <img src={project.projectTools.img1} alt="" />
                <img src={project.projectTools.img2} alt="" />
                <img src={project.projectTools.img3} alt="" />
                <img src={project.projectTools.img4} alt="" />
                <img src={project.projectTools.img5} alt="" />
            </div>
          </div>
          {/* project aim */}
          <div className="paim">
            <div className='pheader'>Aim</div>
            <p>{project.description.desc2}</p>
          </div>
          {/* development process */}
          <div className="devprocess">
            <div className='pheader'>Development Process</div>
            <div className="flex">
              <div className="bgimg">
                <img src={img2} alt="" />
                <div>Research</div>
              </div>
              <div className="bgimg">
                <img src={img} alt="" />
                <div>Design</div>
              </div>
              <div className="bgimg">
                <img src={img1} alt="" />
                <div>Develop</div>
              </div>
            </div>
          </div>
          {/* presearch */}
          <div className="pres">
            <div className="bgimg">
                <img src={img2} alt="" />
                <div>Research</div>
            </div>
            <p>{project.description.desc3}</p>
            <p>{project.description.desc4}</p>
          </div>
          {/* project design */}
          <div className="pdes">
            <div className="bgimg">
                <img src={img} alt="" />
                <div>Design</div>
            </div>
            <div className="img">
              <img src={project.designImg.img1} alt="" />
              <img src={project.designImg.img2} alt="" />
              <img src={project.designImg.img3} alt="" />
              <img src={project.designImg.img4} alt="" />
              <img src={project.designImg.img5} alt="" />
              <img src={project.designImg.img6} alt="" />
            </div>
          </div>
          {/* project development */}
          <div className="pdeve">
            <div className="bgimg">
                <img src={img1} alt="" />
                <div>Develop</div>
            </div>
            <p>{project.description.desc5}</p>
            <p>{project.description.desc6}</p>
          </div>
        </div>
    </>
  )
}

export default ProjectDetials
